export const config = {
  primaryColor: '#002C71',
  primaryRGB: [0, 44, 113],
  accentColor: '#F3B229',
  blackColor: '#000000',
  grayColor: '#444444',
  lightGrayColor: '#777777',
  sectionTitleFontSize: 10,
  fieldTitleFontSize: 11,
  normalFontSize: 8,
  fontFamily: 'Lato',
  dateFormat: 'MMMM DD, YYYY',
  pagePadding: '80 50 50 50'
}
